module.exports = __webpack_public_path__ + "img/yx_logo_w.61fd8892.png";